<template>
  <v-container
    id="profile-actions-view"
    fluid
    tag="section"
  >
    <material-card
      icon="$actions"
      icon-small
      color="accent"
      :title="page_title"
    >
      <v-card-text>
        <v-col
          v-if="checkModule('financial')"
          class="py-1"
        >
          <question-btn
            color="warning"
            simple-button
            :title="$t('recalculate_transactions')"
            tooltip="tooltip_recalculate"
            question="recalculate_question"
            question-description="recalculate_description"
            @click="clickReCalculate"
          />
          {{ $t('fields.transaction_start') }}: {{ profile.organization.transaction_start }}
        </v-col>
        <v-col
          v-if="checkModule('membership')"
          class="py-1"
        >
          <v-btn
            @click="clickDeductionMembershipFee"
          >
            {{ $t('deduction_membership_fees') }}
          </v-btn>
        </v-col>
        <v-col
          v-if="[138,144,217].includes(profile.organization.id)"
          class="py-1"
        >
          <v-btn
            color="primary"
            @click="getReport({ type: 'airport-use-license'})"
          >
            {{ $t('get_airport_use_licences') }}
          </v-btn>
        </v-col>
        <v-col
          v-if="[1,2,150].includes(profile.organization.id)"
          class="py-1"
        >
          <v-btn
            color="primary"
            @click="getReport({ type: 'company-authorization'})"
          >
            {{ $t('get_company_authorization') }}
          </v-btn>
        </v-col>
        <v-col class="py-1">
          <action-organization-user-invitation />
        </v-col>
        <v-col class="my-2 py-0">
          <action-user-organization-guest-apply
            type="organization"
          />
        </v-col>
      </v-card-text>
    </material-card>
  </v-container>
</template>

<script>
  // Utilities
  import { get, call, dispatch } from 'vuex-pathify'
  import ActionOrganizationUserInvitation from '@/layouts/default/action/OrganizationUserInvitation'
  import ActionUserOrganizationGuestApply from '@/layouts/default/action/UserOrganizationGuestApply'

  export default {
    name: 'OrganizationActions',
    components: {
      ActionUserOrganizationGuestApply,
      ActionOrganizationUserInvitation,
    },
    data () {
      return {
        editedPassword: {},
        dialogEditPassword: false,
      }
    },
    computed: {
      profile: get('auth/profile'),
      page_title () { return this.$t('actions') },
    },
    watch: {
    },
    mounted () {
    },
    methods: {
      getReport: call('action/getReport'),
      deductionMembershipFee: call('action/deductionMembershipFee'),
      recalculateTransactions: call('transaction/reCalculate'),
      async clickReCalculate () {
        await this.recalculateTransactions({}).then(response => {
          dispatch('alert/setSnackbar', { text: 'ReCalculate Success!', type: 'success' })
        }).catch(e => {
          dispatch('alert/setSnackbar', { text: e.message, type: 'error' })
          console.log(e)
        })
      },
      async clickDeductionMembershipFee () {
        await this.deductionMembershipFee({}).then(response => {
          dispatch('alert/setSnackbar', { text: 'Success!', type: 'success' })
        }).catch(e => {
          dispatch('alert/setSnackbar', { text: e.message, type: 'error' })
          console.log(e)
        })
      },
      checkModule (payload) {
        return this.profile.organization.modules.filter(m => m.name === payload).length > 0
      },
    },
  }
</script>
